import { ApolloError } from '@apollo/client'

export const formatGraphQLError = (
    error: ApolloError,
    customErrorMessage: string = 'Please try again'
) => {
    return error?.graphQLErrors?.[0]?.message ?? customErrorMessage
}
